import React from 'react';
import classnames from 'classnames';

import shopify from '../../../utils/shopify';

import CartItem from './CartItem';

class Cart extends React.Component {
	constructor() {
		super();

		this.state = {
			isClosed: true,
			isEmpty: true,
			subtotal: null
		};

		this.clearCart = this.clearCart.bind(this);
		this.checkout = this.checkout.bind(this);
		this.toggleCart = this.toggleCart.bind(this);
		this.closeCart = this.closeCart.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.cart) {
			return null;
		}

		this.setState({
			isEmpty: !Boolean(nextProps.cart.lineItemCount)
		});

		this.setState({
			subtotal: "$" + Math.round(Number(nextProps.cart.subtotal))
		});
	}

	clearCart() {
		this.props.cart.clearLineItems()
			.then((newCart) => {
				this.props.updateCart(newCart);
			})
			.catch((err) => {
				this.error = "Sorry, there was a problem clearing your cart. Try again?";
				console.error(`There was a problem clearing the cart. ${err}`);
			});
	}

	checkout() {
		shopify.clearLocalCart();
		window.location.href = this.props.cart.checkoutUrl;
	}

	getClassNames() {
		let classes = ['cart-wrapper'];

		if (this.state.isEmpty) {
			classes.push('cart-wrapper--is-empty');
		}

		if (this.state.isClosed) {
			classes.push('cart-wrapper--is-closed');
		}

		return classnames(classes);
	}

	toggleCart() {
		this.setState({isClosed: !this.state.isClosed});
	}

	closeCart() {
		this.setState({isClosed: true});
	}

	render() {
		let cartHeading = "Where'd the pets go?";
		let cartToggle;

		if (!this.props.cart) {
			return null;
		}

		if (this.props.cart.lineItemCount > 0) {
			if (this.state.isClosed) {
				cartHeading = this.props.cart.lineItemCount > 1 ?
					`${this.props.cart.lineItemCount} pets are in your cart` :
					`${this.props.cart.lineItemCount} pet is in your cart`;
			} else {
				cartHeading = "Your Cart";
			}
		}

		cartToggle = this.state.isClosed ? "View" : "Close";

		return (
			<div className={this.getClassNames()}>
				<div className="cart-overlay" onClick={this.closeCart} />
				<div className="cart">
					<div className="cart__heading" onClick={this.toggleCart}>
						<span className="cart__heading__text">{cartHeading}</span>
						<a className="cart__link cart__link--toggle-cart">{cartToggle}</a>
					</div>

					<div className="cart__items">
						{this.props.cart.lineItems.map(item => (
							<CartItem key={item.id} cart={this.props.cart} item={item} updateCart={this.props.updateCart} />
						))}
						<div className="cart__items__empty-message">Your cart is empty.<br/><br/>👻</div>
					</div>

					<div className="cart__checkout">
						<div className="cart__checkout__subtotal cart__checkout-flex-wrapper">
							<b>Subtotal:</b>
							<span>{this.state.subtotal}</span>
						</div>
						<a className="button button--checkout alt-color--dark" onClick={this.checkout}>Checkout</a>
						{/*
							<div className="cart__checkout__disclaimer cart__checkout__disclaimer--important">
								Orders placed between 11/30-12/2 will be fulfilled in about 1 week.
							</div>
						*/}
						<div className="cart__checkout__disclaimer">
							Shipping and promotions are added at checkout.
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Cart;



// WEBPACK FOOTER //
// ./src/components/Site/Shop/Cart.js